/**
 * WorkBuddy Cloud SDK 公开入口（#89098）
 *
 * 生成应用只从这里导入。
 *
 * ⚠️ **不要从这里导出 vendor 的类型名**（`PostgrestClient` / `StorageClient` 等）。
 * vendor 是内部实现细节，泄漏到公开 d.ts 会让消费方写出依赖第三方命名的代码，
 * 之后就换不掉了。
 */

export { createWorkBuddyCloud, WorkBuddyCloudClient } from './client.js';
export { CLOUD_MODULE_PATHS, CLOUD_PATH_PREFIX } from './paths.js';
export { WorkBuddyDatabaseModule } from './modules/database.js';
export { AuthModule, type AuthModuleOptions } from './modules/auth/index.js';
export { createMemoryStorage } from './modules/auth/session-store.js';
export { LlmModule, getModelCapability, getModelDisplayName } from './modules/llm.js';
export {
    CloudStoragePathError,
    DEFAULT_SIGNED_URL_TTL_SECONDS,
    MAX_SIGNED_URL_TTL_SECONDS,
    RUNTIME_STORAGE_BUCKET,
    WorkBuddyStorageBucket,
    WorkBuddyStorageDownload,
    WorkBuddyStorageModule,
    type CloudStorageCursorFolder,
    type CloudStorageCursorObject,
    type CloudStorageCursorListOptions,
    type CloudStorageError,
    type CloudStorageFile,
    type CloudStorageFileBody,
    type CloudStorageFileOptions,
    type CloudStorageListOptions,
    type CloudStorageListResult,
    type CloudStorageMetadata,
    type CloudStorageObjectInfo,
    type CloudStorageResult,
} from './modules/storage.js';
export { CloudOpenAIError } from './modules/llm/errors.js';
export type { OpenAIErrorObject, CloudOpenAIErrorInit } from './modules/llm/errors.js';
export type {
    PublicLLMModel,
    PublicModelCapabilities,
    PublicModelModalities,
    PublicModelPricing,
    PublicModelReasoning,
    ChatCompletion,
    ChatCompletionChunk,
    ChatCompletionChoice,
    ChatCompletionChunkChoice,
    ChatCompletionChunkDelta,
    ChatCompletionChunkToolCall,
    ChatCompletionCreateParams,
    ChatCompletionCreateParamsStreaming,
    CompletionUsage,
    ChatCompletionMessage,
    ChatCompletionRequestMessage,
    ChatCompletionAssistantMessage,
    ChatCompletionToolCall,
    ChatCompletionTool,
    ChatCompletionToolChoice,
    ChatCompletionResponseFormat,
    ChatCompletionContentPart,
    ChatCompletionRole,
} from './modules/llm/types.js';
export {
    type AuthStateChangeCallback,
    type AuthStateChangeEvent,
    type CloudAuthEvent,
    type CloudAuthStateCallback,
    type CloudAuthStorage,
    type CloudOAuthProvider,
    type CloudSession,
    type CloudUser,
    type OAuthCredentials,
    type OAuthRedirect,
    type OAuthSignInOptions,
    type OAuthStartResult,
    type OtpChallenge,
    type OtpCredentials,
    type OtpSignInChallenge,
    type OtpVerifyCredentials,
    type PasswordResetChallenge,
    type PasswordResetUpdate,
    type PasswordCredentials,
    type PhonePasswordCredentials,
    type ResetPasswordWithOldCredentials,
    type SignUpCredentials,
    type VerifyOtpParams,
} from './modules/auth/types.js';
export {
    type CloudError,
    type CloudErrorKind,
    type CloudResult,
    shouldClearCredentials,
} from './http/errors.js';
export {
    anonymousTokenProvider,
    PUBLISHABLE_KEY_HEADER,
    type SessionTokenProvider,
} from './http/fetch.js';
export {
    type CloudModuleName,
    type CloudRuntimeConfig,
    WorkBuddyCloudConfigError,
    type WorkBuddyCloudOptions,
} from './types.js';
